// Shared keyboard focus indicator for interactive components.

/** Standard focus ring — sits 2px outside the control. */
export const FOCUS_RING =
    'outline-none focus-visible:outline-offset-2 focus-visible:[outline:2px_solid_var(--malachite-text-primary)]';

/**
 * Inset focus ring — drawn 2px inside the element edge. Use for full-bleed elements
 * inside an `overflow-hidden` container (e.g. Surface.Row) where an outset outline
 * would be clipped.
 */
export const FOCUS_RING_INSET =
    'outline-none focus-visible:[outline:2px_solid_var(--malachite-text-primary)] focus-visible:[outline-offset:-2px]';

/** Ring drawn on a wrapper when a control *inside* it takes focus. */
export const FOCUS_RING_WITHIN =
    'outline-none has-[:focus-visible]:outline-offset-2 has-[:focus-visible]:[outline:2px_solid_var(--malachite-text-primary)]';

/** Ring for a control on the SelectionBar, where `FOCUS_RING` would be invisible. */
export const FOCUS_RING_SELECTION_BAR =
    'outline-none focus-visible:outline-offset-2 focus-visible:[outline:2px_solid_var(--malachite-selection-bar-foreground)]';

/** Inset ring for a control on the InlineConfirm chip. */
export const FOCUS_RING_INLINE_CONFIRM_INSET =
    'outline-none focus-visible:[outline:2px_solid_var(--malachite-inline-confirm-foreground)] focus-visible:[outline-offset:-2px]';
